import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'app-notification-popup',
  templateUrl: './notification-popup.component.html',
  styleUrl: './notification-popup.component.scss'
})
export class NotificationPopupComponent {
  @Input() notificationsDetails: any;
  notificationList: Array<any> = []

  constructor(
    private router: Router,
    private headerService: HeaderService
  ) { }

  ngOnInit() {
    if (this.notificationsDetails && this.notificationsDetails.totalNotifications > 0) {
      this.notificationList = this.notificationsDetails.notificationsList;
    }
  }

  viewAllClick() {
    this.router.navigate(['/home/notifications'])
  }

  notificationClick(item: any) {
    this.headerService.updateSelectedNotification(item);
    this.router.navigate(['/home/notifications'])
  }
}
